module.exports = __webpack_public_path__ + "img/logo.9e558803.png";